export const API_ROOT_URL = process.env.REACT_APP_API_ENDPOINT;
export const REQUEST_TIMEOUT = 30 * 1000;
export const UPLOAD_TIMEOUT = 150 * 1000;
export const KIBANA_ENDPOINT = "https://c300c4b4a1b342bea54fdb8110b67501.us-west-2.aws.found.io:9243"